exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table thead tr th[data-v-06bc1522]:first-child{text-align:left}table tr td h3[data-v-06bc1522]{text-align:left;margin:.5rem 0}table tr td h3 span[data-v-06bc1522]{color:#666}table tr td p[data-v-06bc1522]{font-size:.7rem;margin:0;text-align:left}@media only screen and (max-width:768px){table[data-v-06bc1522]{white-space:normal}table thead[data-v-06bc1522]{display:none}table tbody[data-v-06bc1522]{display:block}table tr[data-v-06bc1522]{display:flex;flex-direction:column;margin-bottom:1rem;background:#fff}table td[data-v-06bc1522]:nth-child(2){font-weight:700;color:#fff;background:#036;text-align:left}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06bc1522","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/calc/Medicine.vue
// module id = 144
// module chunks = 0